import { actionCreator } from '../../utils/actions';

export const loginButtonClick = actionCreator('Auth/LOGIN_BUTTON_CLICK');
export const confirmRegisterClick = actionCreator('Auth/CONFIRM_REGISTER_CLICK');
export const logoutButtonClick = actionCreator('Auth/LOGOUT_BUTTON_CLICK');
export const registerButtonClick = actionCreator('Auth/REGISTER_BUTTON_CLICK');
export const requestPasswordClick = actionCreator('Auth/REQUEST_PASSWORD_CLICK');
export const resetPhoneClick = actionCreator('Auth/RESET_PHONE_CLICK');
export const signContract = actionCreator('Auth/SIGN_CONTRACT');

export const checkUserClick = actionCreator('Auth/CHECK_USER_CLICK');



// WEBPACK FOOTER //
// ./src/components/Auth/actions.js